// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"4d048155728602cb1b42","691":"2734b6cd2558bcc01ec9","731":"b4e4070953ae4c8c931b","843":"a7263bfcc4188f05c927"}[chunkId] + ".js";
};